

import { useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'

import { loginWithTwitch } from './Utils'
import { backendAccessGet, backendAccessPost } from '../../Utils/Authentication'

import { FaTwitch } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";

const formatTimestamp = (timestamp) => {
    if (!timestamp) return '';
    
    const year = timestamp.toString().substring(0, 4);
    const month = timestamp.toString().substring(4, 6);
    const day = timestamp.toString().substring(6, 8);
    const hour = timestamp.toString().substring(8, 10);
    const minute = timestamp.toString().substring(10, 12);
    const second = timestamp.toString().substring(12, 14);
    
    const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
    
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
};

export function AccountBox({ children, title, icon, isConnected }) {
    return (
        <div style={{ width:'550px',height:'160px', padding:'20px', borderRadius:'10px', marginBottom: '20px' }}>
            <div style={{ width:'100%', marginBottom:'20px'}}>
                <div className="fw-bolder" style={{ float:'left', color:'#303030'}}>
                    {icon}
                    {title}
                </div> 
            </div>
            <div style={{ clear: 'both' }}>
                {children}
            </div>
        </div>
    )
}
export function TwitchAccount( props )
{  
    const accounts = props.accounts 
    const setAccounts = props.setAccounts

    const revokeAccess = () => {
        let data = {}
        data['platform'] = 'twitch'

        backendAccessPost('/api/accounts/revoke-access/', data ).then( res => {
            if( res.error_message )
            {
                alert( res.error_message )
                return 
            }

            setAccounts( res.accounts )
        })
    }

    return (
        <div style={{ width:'100%', padding:'20px', borderRadius:'5px'}}>
                
                {/* { accounts.twitch && */}
                <>
                <div >
                <div className="d-flex justify-content-start" style={{ width:'100%', marginBottom:'5px'}}>
                    Username: <b style={{ marginLeft:'10px'}}>
                        {accounts.twitch ?
                        accounts.twitch.username
                        :
                      <span>zohreh shangi</span> 
                        }
                      
                    </b>
                </div>
                <div className="d-flex justify-content-start" style={{ width:'100%', marginBottom:'20px'}}>
                    Access date: <b style={{ marginLeft:'10px'}}>
                            {accounts.twitch ?
                           formatTimestamp(accounts.twitch.data.timestamp) 
                           :
                    <span>2025-07-01</span> 
                            }
                        </b>
                </div>
                </div>
                <div className="d-flex justify-content-start" style={{ width:'100%'}}>
                    <Button size="sm" onClick={revokeAccess} variant="dark">Revoke access</Button>
                </div>
                </>
              
{/* } */}

                {/* { ( accounts.twitch == null ) &&

                    <div className="d-flex justify-content-end" style={{ width:'100%', marginTop:'30px'}}>
                        <Button size="sm" onClick={e => loginWithTwitch("accounts")}>Grant access
                        </Button>
                    </div>
                } */}
        </div>
    )

    if( accounts.twitch )
    {
        return (
            <div>
                <div className="d-flex justify-content-left align-items-center"
                    style={{ height:'40px', width:'100%'}}>
                    <b>Twitch</b>
                </div>
            <div className="d-flex justify-content-left align-items-center"
                 style={{ height:'20px', width:'100%'}}>
                <Button onClick={ e => loginWithTwitch("accounts") }>Connect</Button>
            </div>
        </div>
        )
    }

    return 
}

export function YoutubeAccount( props )
{  
    const accounts = props.accounts 
    const setAccounts = props.setAccounts

    const revokeAccess = () => {
        let data = {}
        data['platform'] = 'google'

        backendAccessPost('/api/accounts/revoke-access/', data ).then( res => {
            if( res.error_message )
            {
                alert( res.error_message )
                return 
            }

            setAccounts( res.accounts )
        })
    }

    return (
        <div style={{ width:'100%', padding:'20px', borderRadius:'5px'}}>
                
               
                <>
                   <div>
                <div className="d-flex justify-content-start" style={{ width:'100%', marginBottom:'5px'}}>
                    Username : <b style={{ marginLeft:'10px'}}>
                     { accounts.google ?
                        accounts.google.username 
                        :
                        <span>----</span>
                     }
                        </b>
                </div>
                <div className="d-flex justify-content-start" style={{ width:'100%', marginBottom:'20px'}}>
                    Access date: 
                    <b style={{ marginLeft:'10px'}}>
                          { accounts.google ?
                           formatTimestamp(accounts.google.data.timestamp) 
                          :
                             <span>----</span>
                          }
                    </b>
                </div>
                </div>
           
                   { ( accounts.google == null ) ?
                         <div className="d-flex justify-content-start" style={{ width:'100%'}}>
                        <Button size="sm" onClick={e => loginWithTwitch("accounts")}>Grant access</Button>
                    </div>
                    :
                         <div className="d-flex justify-content-start" style={{ width:'100%'}}>
                    <Button size="sm" onClick={revokeAccess} variant="dark">Revoke access</Button>
                </div>
                }
                </>
                

             
        </div>
    )

    if( accounts.google )
    {
        return (
            <div>
                <div className="d-flex justify-content-left align-items-center"
                    style={{ height:'40px', width:'100%'}}>
                    <b>Youtube</b>
                </div>
            <div className="d-flex justify-content-left align-items-center"
                 style={{ height:'20px', width:'100%'}}>
                <Button onClick={ e => loginWithTwitch("accounts") }>Connect</Button>
            </div>
        </div>
        )
    }

    return 
}


export function AccountComponent({ 
    accounts, 
    setAccounts, 
    platform, 
    platformKey, 
    usernameLabel = "Username",
    loginFunction = loginWithTwitch 
}) {
    const revokeAccess = () => {
        let data = {}
        data['platform'] = platform

        backendAccessPost('/api/accounts/revoke-access/', data ).then( res => {
            if( res.error_message ) {
                alert( res.error_message )
                return 
            }
            setAccounts( res.accounts )
        })
    }

    const accountData = accounts[platformKey]

    return (
        <div style={{ width:'100%', padding:'20px', borderRadius:'5px'}}>
            {accountData ? (
                <>
                    <div className='d-flex'>
                        <div className="d-flex justify-content-start" style={{ width:'50%', marginBottom:'5px'}}>
                            {usernameLabel}: <b style={{ marginLeft:'10px'}}>{accountData.username}</b>
                        </div>
                        <div className="d-flex justify-content-start" style={{ width:'50%', marginBottom:'20px'}}>
                            Access date: <b style={{ marginLeft:'10px'}}>{accountData.data?.timestamp}</b>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end" style={{ width:'100%'}}>
                        <Button size="sm" onClick={revokeAccess} variant="dark">Revoke access</Button>
                    </div>
                </>
            ) : (
                <div className="d-flex justify-content-end" style={{ width:'100%', marginTop:'30px'}}>
                    <Button size="sm" onClick={e => loginFunction("accounts")}>Grant access</Button>
                </div>
            )}
        </div>
    )
}

export default function InternetAccounts( props )
{
    const accounts = props.accounts
    const setAccounts = props.setAccounts 

    useEffect( () => {
        backendAccessGet('/api/accounts/get-accounts/').then( res => {
            if( res.error_message )
            {
                alert( res.error_message )
                return
            }

            setAccounts( res.accounts )
        })
    },[])

    return (
      <Container className="d-flex" style={{ maxWidth:'700px', height:'100%', overflowY:'scroll',paddingTop:'50px',gap:'20px'}}>
    <AccountBox 
        title="Twitch" 
        icon={<FaTwitch style={{ color: accounts.twitch ? '#6441a5' : '#6441a5', fontSize:'30px', marginRight:'10px' }} />}
    >
        <TwitchAccount accounts={accounts} setAccounts={setAccounts} />
    </AccountBox>
    
    <AccountBox 
        title="YouTube" 
        icon={<FaYoutube style={{ color: accounts.google ? '#FF0000' : '#D7D7D7', fontSize:'30px', marginRight:'10px' }} />}
    >
        <YoutubeAccount accounts={accounts} setAccounts={setAccounts} />
    </AccountBox>
</Container>
    )
}
